import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { HomePage } from '../HomePage';
import { InstallApp } from '../Help/InstallApp';
import { InventoryPage } from '../InventoryPage';
import { ReceivingPage } from '../Receiving';

import VerifiedMap from '../VerifiedMap';
import ImportVerification from '../ImportVerification';
import { TrainingMaterials } from '../Help/TrainingMaterials';
import { TransferredItemsForm } from '../../components/VerificationForms/TransferredItemsForm';
import { RequestEOneReadyPage } from '../Receiving/RequestsEOneReadyPage';
import { BarcodedPage } from '../Receiving/BarcodedPage';
import { CreateVerificationPage } from '../InventoryPage/CreateVerification';
import { EditVerificationPage } from '../InventoryPage/EditVerification';
import { ViewVerificationPage } from '../InventoryPage/ViewVerification';
// import {Transfers} from '../AssetRelocation/Transfer';
// import {Salvage} from '../AssetRelocation/Salvage'
import { EditRequestPage } from '../Receiving/EditRequest';
import { EditRequestedItemPage } from '../Receiving/EditRequestedItem';
import { EditEOnePage } from '../Receiving/EditEOneItem';
import { CreateRequest } from '../Receiving/CreateRequest';
import { EditTransferPage } from '../AssetRelocation/EditTransferPage';
import { TransferredItems } from '../AssetRelocation/TransferredItems';
import { OITStock } from '../Stock';
import { SalvageItems } from '../AssetRelocation/SalvageItems';
import { EditSalvagePage } from '../AssetRelocation/EditSalvagePage';
import { OrderReport } from '../Receiving/OrderReport/OrderReport';
import { LoggedOut } from '../LogoutPage';

import { RequestsPage } from '../Receiving/RequestsPage';
import { OrderedPage } from '../Receiving/OrderedPage';
import { NonBarcodedPage } from '../Receiving/NonBarcodedPage';
import { RequestEOneSuccessPage } from '../Receiving/RequestsEOneSuccessPage';
import { RequestEOneErrorsPage } from '../Receiving/RequestsEOneErrorsPage';
import { TransfersInitiatedPage } from '../AssetRelocation/TransferredItems/InitiatedPage';
import { TransfersRecievedPage } from '../AssetRelocation/TransferredItems/RecievedPage';
import { TransfersPendingApprovalPage } from '../AssetRelocation/TransferredItems/PendingApprovalPage';
import { TransfersEOneReadyPage } from '../AssetRelocation/TransferredItems/TransfersEOneReadyPage';
import { TransfersEOneSuccessPage } from '../AssetRelocation/TransferredItems/TransfersEOneSuccessPage';
import { TransfersEOneErrorsPage } from '../AssetRelocation/TransferredItems/TransfersEOneErrorsPage';
import { RunAs } from '../DevTeam/RunAs';
import { PurchaseOrders } from '../PurchaseOrders';
import { CreatePurchaseOrder } from '../PurchaseOrders/CreatePurchaseOrder';
import { EditPurchaseOrderPage } from '../PurchaseOrders/EditPurchaseOrder';

export const MainSwitch = () => {
  return (
    <Switch>
      {/** Root dashboard item routes */}
      <ProtectedRoute exact path='/' component={HomePage} />
      <ProtectedRoute path='/userRequests' component={HomePage} />
      <ProtectedRoute path='/importVerifications' component={ImportVerification} />
      <ProtectedRoute path='/map' component={VerifiedMap} />
      <ProtectedRoute path='/installApp' component={InstallApp} />
      <ProtectedRoute path='/trainingMaterials' component={TrainingMaterials} />

      {/** Routes for handling and accessing annual Inventory information */}
      <ProtectedRoute path='/inventory' exact component={InventoryPage} />
      <ProtectedRoute path='/inventory/edit/:id' component={TransferredItemsForm} />
      <ProtectedRoute path='/inventory/create/:key/:type' component={CreateVerificationPage} />
      <ProtectedRoute path='/inventory/editVerification/verifyId=:verifyId/:toTransfer/:created' component={EditVerificationPage} />
      <ProtectedRoute path='/inventory/view/verifyId=:verifyId' component={ViewVerificationPage} />

      {/** Routes for handling and accessing item procurement */}
      <ProtectedRoute path='/requests' exact component={RequestsPage} />
      <ProtectedRoute path='/requests/ordered' exact component={OrderedPage} />
      <ProtectedRoute path='/requests/barcoded' exact component={BarcodedPage} />
      <ProtectedRoute path='/requests/nonBarcoded' exact component={NonBarcodedPage} />
      <ProtectedRoute path='/requests/eOneReady' exact component={RequestEOneReadyPage} />
      <ProtectedRoute path='/requests/eOneSuccess' exact component={RequestEOneSuccessPage} />
      <ProtectedRoute path='/requests/eOneErrors' exact component={RequestEOneErrorsPage} />
      <ProtectedRoute path='/receiving' exact component={ReceivingPage} />
      <ProtectedRoute path='/receiving/view/requestId=:requestId' component={EditRequestPage} />
      <ProtectedRoute path='/receiving/view/requestedItemId=:requestedItemId' component={EditRequestedItemPage} />
      <ProtectedRoute path='/receiving/create' exact component={CreateRequest} />

      <ProtectedRoute path='/purchaseOrders' exact component={PurchaseOrders} />
      <ProtectedRoute path='/purchaseOrders/create' exact component={CreatePurchaseOrder} />
      <ProtectedRoute path='/purchaseOrders/update/po=:poId' component={EditPurchaseOrderPage} />

      {/* <Route path='/purchaseOrders' exact component={PurchaseOrders} />
      <Route path='/purchaseOrders/create' exact component={CreatePurchaseOrder} />
      <Route path='/purchaseOrders/update/po=:poId' component={EditPurchaseOrderPage} /> */}

      {/** Routes for handling and accessing Transfer information */}
      <ProtectedRoute path='/transfers' exact component={TransfersInitiatedPage} />
      <ProtectedRoute path='/transfers/recieved' exact component={TransfersRecievedPage} />
      <ProtectedRoute path='/transfers/pendingApproval' exact component={TransfersPendingApprovalPage} />
      <ProtectedRoute path='/transfers/eOneReady' exact component={TransfersEOneReadyPage} />
      <ProtectedRoute path='/transfers/eOneSuccess' exact component={TransfersEOneSuccessPage} />
      <ProtectedRoute path='/transfers/eOneErrors' exact component={TransfersEOneErrorsPage} />
      <ProtectedRoute exact path='/transfers/approval/:eOneId' component={EditTransferPage} />
      <ProtectedRoute exact path='/transfers' component={TransferredItems} />

      <ProtectedRoute path='/assets/view/eOneId=:eOneId' component={EditEOnePage} />
      <ProtectedRoute exact path='/salvage' component={SalvageItems} />
      <ProtectedRoute exact path='/salvage/approval/:salvageId' component={EditSalvagePage} />
      <ProtectedRoute exact path='/oitStock' component={OITStock} />

      <ProtectedRoute exact path='/dev/runAsUser' component={RunAs} />

      <Route exact path='/loggedOut' component={LoggedOut} />
      <Route exact path='/loggedOut/sso' component={LoggedOut} />

      {/* <ProtectedRoute path='/salvage' exact component={Salvage} /> */}
    </Switch>
  );
};
